import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDrawer } from '@angular/material/sidenav';
import { BehaviorSubject, filter } from 'rxjs';
import { ResponsiveService } from '../../wonder-core-ng/services/responsive.service';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private responsiveService = inject(ResponsiveService);

  private drawer!: MatDrawer;
  private drawerShrinkSource = new BehaviorSubject(false);
  public drawerShrink$ = this.drawerShrinkSource.asObservable();
  public drawerShrink = toSignal(this.drawerShrink$);

  constructor() {
    this.responsiveService.handset$
      .pipe(filter((handset) => handset))
      .subscribe(() => this.drawer?.close());
    this.responsiveService.medium$
      .pipe(filter((handset) => handset))
      .subscribe(() => this.setDrawerShrink(true));
  }

  setDrawer(drawer: MatDrawer): void {
    this.drawer = drawer;
  }

  toggleDrawer(): void {
    this.drawer?.toggle();
  }

  setDrawerShrink(shrink: boolean): void {
    this.drawerShrinkSource.next(shrink);
  }

  toggleDrawerShrink(): void {
    this.drawerShrinkSource.next(!this.drawerShrinkSource.value);
  }
}
